import { makeObservable } from 'mobx'
import { getSectionProductsBySectionId } from '../firestore/SectionProduct'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { SectionProduct } from '../models/SectionProduct'
import { Cubit } from './core'

export class SectionProductController extends Cubit {
  repository: FirebaseRepository

  sectionProductStreamsById: Map<string, SectionProduct> = new Map()

  constructor(repository: FirebaseRepository) {
    super()
    makeObservable(this)
    this.repository = repository
  }

  dispose(): symbol {
    this.sectionProductStreamsById.clear()
    return super.dispose()
  }

  getLatestForSectionId = (sectionId: string) => {
    if (this.sectionProductStreamsById.has(sectionId)) {
      return this.sectionProductStreamsById.get(sectionId)!
    }

    const emptyProduct = SectionProduct.empty(this.repository)

    this.sectionProductStreamsById.set(sectionId, emptyProduct)

    this.addStream(
      getSectionProductsBySectionId(this.repository, { sectionId }),
      (sectionProducts) => {
        const sortedProducts = [...sectionProducts].sort((a, b) => {
          const aTime = a.data.updatedAt?.getTime() || 0
          const bTime = b.data.updatedAt?.getTime() || 0
          return bTime - aTime
        })

        const product = sortedProducts[0]
        emptyProduct.replaceModel(product)
      }
    )

    return emptyProduct
  }
}
